import React, { ReactNode } from 'react';
import { Box, Button, Stack, type SxProps, type Theme, useTheme } from '@mui/material';

import PlusIcon from '@/assets/icons/plus.svg?react';

type EmptyStateProps = {
  imageUrl?: string;
  imageAlt?: string;
  imageSx?: SxProps<Theme>;
  children: ReactNode;
  buttonLabel?: string;
  onCreate?: () => void;
  buttonIcon?: ReactNode;
};

const EmptyState = ({ imageAlt, imageUrl, imageSx, buttonLabel, children, onCreate, buttonIcon }: EmptyStateProps) => {
  const { spacing } = useTheme();

  return (
    <Stack direction="column" spacing={spacing(2)} alignItems="center">
      {imageUrl && (
        <Box
          component="img"
          src={imageUrl}
          alt={imageAlt ? imageAlt : imageUrl}
          sx={imageSx || { width: spacing(30) }}
        />
      )}
      {children}
      {onCreate && (
        <Button variant="contained" startIcon={buttonIcon ?? <PlusIcon />} onClick={onCreate}>
          {buttonLabel}
        </Button>
      )}
    </Stack>
  );
};

export default EmptyState;
